/**
 * Test component that throws an error during render to test the ErrorBoundary.
 * This is only accessible to Team DSIT members for testing purposes.
 */
export const TestError = () => {
  throw new Error("Test error triggered from render - ErrorBoundary should catch this");
};
